(() => {
  angular
    .module('app.ics')
    .controller('IcsReportController', IcsReportController);

  IcsReportController.$inject = [
    '$scope',
    'InterceptionReport',
    'Interceptions',
    '$timeout',
    'ChartService',
  ];

  function IcsReportController(
    $scope,
    InterceptionReport,
    Interceptions,
    $timeout,
    ChartService,
  ) {
    const vm = this;

    vm.reportLoaded = false;
    vm.isAdminTabVisible = window.ICS_ADMIN;
    vm.interceptionId = window.ICS_CONFIG.interceptionId;

    vm.currentTab = 0;
    vm.campaignName = '';
    vm.warningVisible = false;
    vm.dates = null;

    vm.include = {
      device: [
        'Unknown',
        'Desktop',
        'Mobile',
        'Table',
      ],
    };

    vm.reflowDetails = function () {
      if (angular.isDefined($('#ircDetails').highcharts())) {
        $timeout(function () {
          $('#ircDetails').highcharts().reflow();
        }, 15);
      }
    };

    vm.reflowOverview = function () {
      if (angular.isDefined($('#ircOverview').highcharts())
        && angular.isDefined($('#ircDeviceTypeRatio').highcharts())) {
        $timeout(function () {
          $('#ircOverview').highcharts().reflow();
          $('#ircDeviceTypeRatio').highcharts().reflow();
        }, 15);
      }
    };

    vm.setCurrentTabTo = function (tab) {
      if (tab == 0) {
        vm.reflowOverview();
      } else {
        vm.reflowDetails();
      }
      vm.currentTab = tab;
    }

    Interceptions.get({id: window.ICS_CONFIG.interceptionId}, {}, function (model) {
      vm.campaignName = model.name;
    });


    function placeThousandDots(value) {
      var s = value + '';

      var parts = [];

      while (s.length > 3) {
        var p = s.substr(-3);
        parts.push(p);
        s = s.substr(0, s.length - 3);
      }

      if (s.length > 0) {
        parts.push(s);
      }

      parts = parts.reverse();
      return parts.join();
    }

    function formatToolTip(item) {
      var trs = '';
      for (var i = 0; i < item.points.length; i++) {
        var p = item.points[i];
        var dotted = placeThousandDots(p.y);
        trs = trs + '<tr><td class="td-left">' + p.series.name + ':</td>'
          + '<td class="td-right">' + dotted + '</td>' +
          '</tr>';
      }

      return '<h4>Data for - ' + item.x + '</h4>' +
        '<div class="highcharts-tooltip-outer">' +
        '<table class="highcharts-tooltip-inner">' + trs + '</table></div>';
    }

    // Charts begin
    var ratesByDayOptions = ChartService.getBaseChartConfig();
    angular.merge(ratesByDayOptions, {
      chart: {
        type: 'column'
      },
      colors: ['#9ee00f'],
      tooltip: {
        formatter: function () {
        return formatToolTip(this);
      }
    },
    plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0
        }
      },
      title: {
        text: "Detailed statistics"
      },
      xAxis: {
        categories: [],
        crosshair: true,
        labels: {
          step: 1,
          rotation: -90
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Count'
        }
      },
    });

    function formatInt(i) {
      return ('000' + i).slice(-2);
    }

    function formatDate(d) {
      var date = new Date(d);
      return date.getFullYear() + '-' + formatInt(date.getMonth() + 1) + '-' + formatInt(date.getDate());
    }

    function refreshSeries(dataSource, chart, filter) {
      if (angular.isObject(dataSource) == false) return;

      for (var s = 0; s < chart.series.length; s++) {
        chart.series[s].data = [];
      }

      for (var d = 0; d < dataSource.length; d++) {
        for (var s = 0; s < chart.series.length; s++) {
          var serie = chart.series[s];

          var serieValue = 0;
          for (var j = 0; j < dataSource[d].items.length; j++) {
            var v = dataSource[d].items[j];
            var addValue = 0;
            if (filter.indexOf(v.deviceType) >= 0) {
              addValue = v[serie.name.toLowerCase()]
            }

            serieValue = serieValue + addValue;
          }
          serie.data.push(serieValue);
        }

        chart.options.xAxis.categories.push(formatDate(dataSource[d].date));
      }
    }

    vm.ratesByDayDetails = {
      options: ratesByDayOptions,
      refreshData: function (dataSource, filter) {
        refreshSeries(dataSource, vm.ratesByDayDetails, filter);
      },
      series: [{
        name: 'Shows',
        visible: false,
      }, {
        name: 'Accepts',
      }, {
        name: 'Declines',
        visible: false,
      }, {
        name: 'Rejects',
        visible: false,
      }]
    };

    vm.ratesByDayDetails.options.colors = [
      '#16d6d8',
      '#9ee00f',
      '#decade',
      '#ee5757',
    ];

    // Pie chart begin
    var deviceTypeRatioChartOptions = ChartService.getBaseChartConfig();
    angular.merge(deviceTypeRatioChartOptions, {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 45
        },
        height: 280,
        spacingTop: 0,
        spacingLeft: -540 // Approx half the pie and legend width
      },
      tooltip: {
        formatter: function () {
          return '<div class="highcharts-tooltip-outer"><table class="highcharts-tooltip-inner"><tr><td class="td-left">' +
              this.point.name + ':</td><td class="td-right">' + this.y + '%</td></tr></table></div>';
        }
      },
      legend: {
        y: 70,
        x: 460,
        backgroundColor: 'transparent',
        useHTML: true,
        labelFormatter: function () {
          return '<div class="dtr-legend dtr-legend-' + this.name.toLowerCase() + '"><i></i><span class="dtr-legend-name"><span>' +
            this.name + '</span></span>' + this.y + '%</div>';
        },
        width: 540,
        itemWidth: 270,
        itemStyle: {
          fontFamily: 'Bold',
          fontSize: '16px',
          lineHeight: '70px',
          width: 270
        },
        symbolHeight: 0,
        symbolWidth: 0
      },
      xAxis: {
        labels: {
          formatter: function () {
            return String("00" + this.value).slice(-2);
          }
        },
        tickInterval: 1
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false
          },
          innerSize: '50%',
          depth: 45,
          point: {
            events: {
              legendItemClick: function () {
                $('.dtr-legend-' + this.name.toLowerCase()).toggleClass('is-hidden');
              }
            }
          },
          showInLegend: true
        }
      },
      colors: [
        '#16d6d8',
        '#9ee00f',
        '#4f5a5a',
        '#8a9c9c',
      ]
    });

    vm.deviceTypeRatio = {
      options: deviceTypeRatioChartOptions,
      refreshData: function (dataSource) {
        if (angular.isUndefined(dataSource)) return;

        var total = 0;
        var subTotals = [0, 0, 0, 0];
        for (var d = 0; d < dataSource.length; d++) {
          for (var i = 0; i < dataSource[d].items.length; i++) {
            var v = dataSource[d].items[i];
            total += v.accepts;
            const index = vm.include.device.indexOf(v.deviceType);
            subTotals[index] = subTotals[index] + v.accepts;
          }
        }

        for (var i = 0; i < 4; i++) {
          if (total != 0) {
            subTotals[i] = Math.round((subTotals[i] * 100.0) / total);
          } else {
            subTotals[i] = 0;
          }
        }

        vm.deviceTypeRatio.series = [{
          name: 'DeviceTypes',
          data: [{
            name: 'Desktop',
            y: subTotals[1]
          }, {
            name: 'Mobile',
            y: subTotals[2]
          }, {
            name: 'Tablet',
            y: subTotals[3]
          }, {
            name: 'Other',
            y: subTotals[0]
          }]
        }];
      }
    };

    $scope.$watch(() => vm.include.device,
      newValue => {
        var filter = newValue.join();
        vm.ratesByDayDetails.refreshData(vm.dates, filter);
      }, true);

    InterceptionReport.list({id: window.ICS_CONFIG.interceptionId}, response => {
      if (response.dates && response.dates.length > 0) {
        vm.dates = response.dates;

        if (vm.dates.length > 20) {
          var step = Math.floor(vm.dates.length / 10);
          vm.ratesByDayDetails.options.xAxis.labels.step = step;
        }

        vm.deviceTypeRatio.refreshData(vm.dates);
        vm.ratesByDayDetails.refreshData(vm.dates, vm.include.device.join(','));
      } else {
        vm.warningVisible = true;
      }
      vm.reportLoaded = true;
      vm.reflowOverview();
      vm.reflowDetails();
    });
  }
})();
